$(document).ready(function() {
	$('[data-frm-file-upload]').each(function() {
		const upload = this;
		const input = upload.querySelector('input[type="file"]');
		const dropzone = upload.querySelector('[data-frm-file-dropzone]');
		const list = upload.querySelector('[data-frm-file-list]');
		const message = upload.querySelector('[data-frm-file-message]');

		if (!input || !dropzone || input.dataset.frmFileUploadInitialized === 'true') {
			return;
		}

		input.dataset.frmFileUploadInitialized = 'true';

		const maxFiles = Number.parseInt(upload.dataset.maxFiles || '', 10);
		const maxSizeMb = Number.parseFloat(upload.dataset.maxSize || '');
		const maxSizeBytes = Number.isFinite(maxSizeMb) ? maxSizeMb * 1024 * 1024 : null;
		let selectedFiles = Array.from(input.files || []);
		let previewUrls = [];
		let isSyncingFiles = false;

		const formatFileSize = (bytes) => {
			if (bytes >= 1024 * 1024) {
				return `${(bytes / 1024 / 1024).toFixed(1)} MB`;
			}

			if (bytes >= 1024) {
				return `${Math.round(bytes / 1024)} KB`;
			}

			return `${bytes} B`;
		};

		const fileKey = (file) => `${file.name}-${file.size}-${file.lastModified}`;

		const clearPreviewUrls = () => {
			previewUrls.forEach((url) => URL.revokeObjectURL(url));
			previewUrls = [];
		};

		const syncInputFiles = () => {
			const dataTransfer = new DataTransfer();

			selectedFiles.forEach((file) => dataTransfer.items.add(file));

			isSyncingFiles = true;
			input.files = dataTransfer.files;
			$(input).trigger('change');
			isSyncingFiles = false;
		};

		const updateList = () => {
			clearPreviewUrls();
			list.innerHTML = '';
			upload.classList.toggle('frm-file-upload--has-files', selectedFiles.length > 0);

			selectedFiles.forEach((file, index) => {
				const item = document.createElement('li');
				const preview = document.createElement(file.type.startsWith('image/') ? 'img' : 'span');
				const details = document.createElement('span');
				const filename = document.createElement('span');
				const filesize = document.createElement('span');
				const removeButton = document.createElement('button');

				item.className = 'frm-file-upload__item';
				preview.className = 'frm-file-upload__preview';
				details.className = 'frm-file-upload__details';
				filename.className = 'frm-file-upload__filename';
				filesize.className = 'frm-file-upload__filesize';
				removeButton.className = 'frm-file-upload__remove';
				removeButton.type = 'button';
				removeButton.setAttribute('aria-label', `Retirer ${file.name}`);

				filename.textContent = file.name;
				filesize.textContent = formatFileSize(file.size);
				removeButton.textContent = 'Retirer';

				if (file.type.startsWith('image/')) {
					const previewUrl = URL.createObjectURL(file);
					previewUrls.push(previewUrl);
					preview.src = previewUrl;
					preview.alt = '';
				} else {
					preview.textContent = file.name.split('.').pop()?.slice(0, 4).toUpperCase() || 'FILE';
				}

				removeButton.addEventListener('click', () => {
					selectedFiles.splice(index, 1);
					message.textContent = '';
					syncInputFiles();
					updateList();
				});

				details.append(filename, filesize);
				item.append(preview, details, removeButton);
				list.appendChild(item);
			});
		};

		const setFiles = (files, append = input.multiple) => {
			const notices = [];
			const existingKeys = new Set(append ? selectedFiles.map(fileKey) : []);
			let accepted = append ? [...selectedFiles] : [];

			Array.from(files).forEach((file) => {
				if (!input.multiple && accepted.length) {
					return;
				}

				const key = fileKey(file);

				if (existingKeys.has(key)) {
					return;
				}

				if (maxSizeBytes && file.size > maxSizeBytes) {
					notices.push(`${file.name} depasse ${maxSizeMb} MB.`);
					return;
				}

				accepted.push(file);
				existingKeys.add(key);
			});

			if (Number.isFinite(maxFiles) && maxFiles > 0 && accepted.length > maxFiles) {
				notices.push(`Maximum ${maxFiles} fichier${maxFiles > 1 ? 's' : ''}.`);
				accepted = accepted.slice(0, maxFiles);
			}

			selectedFiles = accepted;
			message.textContent = notices.join(' ');
			syncInputFiles();
			updateList();
		};

		input.addEventListener('change', () => {
			if (isSyncingFiles) {
				return;
			}

			setFiles(input.files, input.multiple);
		});

		$(input).on('resetFrmFileUpload', () => {
			selectedFiles = [];
			message.textContent = '';
			syncInputFiles();
			updateList();
		});

		['dragenter', 'dragover'].forEach((eventName) => {
			dropzone.addEventListener(eventName, (event) => {
				event.preventDefault();
				event.stopPropagation();

				if (!input.disabled) {
					upload.classList.add('frm-file-upload--dragover');
				}
			});
		});

		['dragleave', 'drop'].forEach((eventName) => {
			dropzone.addEventListener(eventName, (event) => {
				event.preventDefault();
				event.stopPropagation();
				upload.classList.remove('frm-file-upload--dragover');
			});
		});

		dropzone.addEventListener('drop', (event) => {
			if (input.disabled || !event.dataTransfer?.files?.length) {
				return;
			}

			setFiles(event.dataTransfer.files);
		});

		updateList();
	});
});
